/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './PreferencesBar.scss';

import classnames from 'classnames';
import { bool } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { ReactComponent as ChevronLeft } from 'assets/icons/chevron-left.svg';
import PreferencesBreadCrumbs from 'components/layouts/Preferences/PreferencesBreadCrumbs';

const PreferencesBar = ({
  children,
  isDesktopLayout,
  isPreferencesBarLoading,
  location,
  backPath = '/profile',
  barClassName
}) => {
  const isLoading = isPreferencesBarLoading;
  const loadingContentClass = classnames('preferences-bar-container', {
    'content-loading': isLoading
  });

  const isBackPath = location.pathname === backPath;
  const preferencesClassName = classnames(`preferences-bar ${barClassName}`, {
    'on-mobile-profile-page': !isDesktopLayout && isBackPath
  });

  return (
    <div className={loadingContentClass}>
      <div className={preferencesClassName}>
        {isDesktopLayout ? (
          <PreferencesBreadCrumbs />
        ) : (
          !isBackPath && (
            <Link className="mobile-back-link" to={backPath}>
              <div className="mobile-back-icon-container">
                <ChevronLeft className="mobile-back-icon" />
                Back
              </div>
            </Link>
          )
        )}
        {children}
      </div>
    </div>
  );
};

PreferencesBar.propTypes = {
  hasError: bool.isRequired,
  isPreferencesBarLoading: bool.isRequired
};

const mapStateToProps = (state, { location }) => ({
  isDesktopLayout: state.view.isDesktopLayout,
  location
});

export default withRouter(connect(mapStateToProps)(PreferencesBar));
